export default function MobileBottomNav() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-background-50/95 backdrop-blur-md border-t border-background-200/60 pb-[env(safe-area-inset-bottom)]">
      <div className="flex items-center gap-2 px-4 py-2.5">
        <button
          onClick={() => scrollTo('ponudba')}
          className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-md bg-primary-500 text-foreground-50 text-xs font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors duration-300"
        >
          <i className="ri-goblet-line"></i>
          Ponudba
        </button>
        <a
          href="https://www.google.com/maps/dir/?api=1&destination=Zamušani+2,+2272+Gorišnica"
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-md border border-foreground-200/30 text-foreground-100 text-xs font-semibold whitespace-nowrap cursor-pointer hover:bg-foreground-50/10 transition-colors duration-300"
        >
          <i className="ri-navigation-line"></i>
          Navigacija
        </a>
      </div>
    </div>
  );
}